import React from 'react'
import styled from '@emotion/styled'
import { fontSize3XSmall, fontSize2XSmall, fontWeightBold } from '../../../constants/principles'
import SecondaryNavComponent from './SecondaryNavComponent'
import IconSvgs from '../IconSvgs'
import { pageObject } from '../../../constants/pageObject'

const SVG_ICONS = ['ABS', 'Airbags', 'Check Engine', 'Service Engine', 'Low Coolant', 'Maintenance', 'Oil Pressure']

const PrimaryTab = ({ make, model, bodyStyle, secondaryTab, setSecondaryTab, label, testId, subNavItems, addImpressions, conditionQuestions, anyAnswered, updateGlobalState, badgeCnt, setBadgeCnt, pushAnalytics, ...props }) => {
  const onClickTab = activeTab => {
    setSecondaryTab(activeTab)

    let impression
    switch (label) {
      case 'Exterior':
        impression = `sm_${activeTab.toLowerCase()}`
        break
      case 'Interior':
        impression = activeTab === 'Seats' ? `sm_seats_carpet_headliner` : `sm_dashboard_lights`
        break
      default:
        break
    }

    pushAnalytics(label)
    updateGlobalState({ fireAnalytics: impression, cp: pageObject[label] })
  }

  return (
    <>
      <IconGroup>
        <SecondaryNavComponent
          navItems={subNavItems}
          activeTab={secondaryTab}
          onClickTabItem={onClickTab}
          tabPrimary={label}
          testId={testId}
          isImage={true}
          model={model}
          make={make}
          bodyStyle={bodyStyle}
          secondaryTabExterior={secondaryTab}
          setSecondaryTabExterior={setSecondaryTab}
          anyAnswered={anyAnswered}
          badgeCnt={badgeCnt}
        />
      </IconGroup>
      <SubheadingContainer>
        {label === 'Exterior' &&
          (secondaryTab === 'Windows' ? (
            <>
              <h1>Do you have damage or wear in these areas?</h1>
              <span>(Example: chips, cracks or replaced items)</span>
            </>
          ) : (
            <>
              <h1>Do you have damage or wear in these areas?</h1>
              <span>(Example: dings, dents, scratches or paint chips)</span>
            </>
          ))}
        {label === 'Interior' &&
          (secondaryTab === 'Seats' ? (
            <>
              <h1>Do you have damage or wear in these areas?</h1>
              <span>(Example: stains, rips, tears, burns or missing parts)</span>
            </>
          ) : (
            <>
              <h1>Do any of these stay on?</h1>
              <span>Please note: Warning lights may not be exactly as shown.</span>
            </>
          ))}
      </SubheadingContainer>
      <StyledContainer>
        <IconSvgs {...{ titleOverride: ' ', subtitleOverride: ' ', disclaimerOverride: ' ', conditionQuestions, svgIcons: SVG_ICONS, setBadgeCnt, isVisible: label === 'Interior' && secondaryTab === 'Dashboard', anyAnswered, ...props }} />
      </StyledContainer>
    </>
  )
}

export const IconGroup = styled.div`
  align-items: stretch;
  display: flex;
  margin: 15px 0;
  height: 106px;
  width: 100%;
  justify-content: space-evenly;
  flex-wrap: wrap;
`
const StyledContainer = styled.div`
  button {
    flex-direction: column;
    align-items: center;
  }
  h1 {
    font-size: 14px;
  }
`

export const SubheadingContainer = styled.div`
  padding-bottom: 20px;
  h1 {
    font-size: ${fontSize2XSmall};
    font-weight: ${fontWeightBold};
  }
  span {
    font-size: ${fontSize3XSmall};
  }
`

export default PrimaryTab
